export function sellbotStatusClass(status: string, styles: Record<string, string>): string {
    switch (status) {
        case 'Completed': return styles.badgeSuccess;
        case 'Refunded': case 'NoMatch': case 'ItemDisabled': case 'PayerMismatch': case 'LimitReached': return styles.badgeWarning;
        case 'OutOfStock': case 'Failed': return styles.badgeDanger;
        case 'Cancelled': return styles.badgeMuted;
        case 'Processing': case 'Received': case 'Delivering': return styles.badgeInfo;
        default: return styles.badgeMuted;
    }
}
